import React, { useEffect } from "react";
import { Helmet } from "react-helmet";

import NavBar from "../components/common/navBar";
import Footer from "../components/common/footer";
import Article from "../components/articles/article";

import { useLanguage } from "../i18n/LanguageContext";

import "./styles/articles.css";

const Articles = () => {
	const { t, messages } = useLanguage();

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const seo = messages.seo.articles;

	return (
		<React.Fragment>
			<Helmet>
				<title>{`${t("titles.articles")} | ${t("main.siteTitle")}`}</title>
				<meta name="description" content={seo.description} />
				<meta name="keywords" content={seo.keywords.join(", ")} />
			</Helmet>

			<div className="page-content">
				<NavBar active="articles" />
				<div className="content-wrapper">
					<br />
					<div className="articles-main-container">
						<div className="title articles-title">
							{messages.articlesIntro.title}
						</div>

						<div className="subtitle articles-subtitle">
							{messages.articlesIntro.description}
						</div>
						<br />
						<div className="articles-container">
							<div className="articles-wrapper">
								{messages.articles.map((article, index) => (
									<div
										className="articles-article"
										key={(index + 1).toString()}
									>
										<Article
											key={(index + 1).toString()}
											date={article.date}
											title={article.title}
											description={article.description}
											link={"/article/" + (index + 1)}
										/>
									</div>
								))}
							</div>
						</div>
					</div>
					<div className="page-footer">
						<Footer />
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default Articles;
